import React from "react";
import { Truck, Package } from "lucide-react";
import type { CompanyType } from "../../../types";

interface CompanyTypeBadgeProps {
  companyType?: CompanyType;
}

const CONFIG: Record<
  CompanyType,
  { label: string; className: string; icon: typeof Truck }
> = {
  forwarder: {
    label: "Forwarder",
    className: "bg-blue-100 text-blue-800",
    icon: Truck,
  },
  shipper: {
    label: "Shipper",
    className: "bg-purple-100 text-purple-800",
    icon: Package,
  },
};

/** Tenant persona badge. Companies created before the field default to forwarder. */
const CompanyTypeBadge: React.FC<CompanyTypeBadgeProps> = ({ companyType }) => {
  const {
    label,
    className,
    icon: Icon,
  } = CONFIG[companyType || "forwarder"] ?? CONFIG.forwarder;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full ${className}`}
    >
      <Icon className="w-3 h-3" />
      {label}
    </span>
  );
};

export default CompanyTypeBadge;
